module.exports = __webpack_public_path__ + "img/27exp.6802001c.jpg";